import { useState } from 'react';

import { Button, Checkbox, DatePicker, Modal, Text } from '@pukka/ui-components';
import { isAfter } from 'date-fns';

import { DetailedCampaignWithStatusAndLoadingFalse } from './CustomerDisplay.state';
import { tomorrow } from './utils';

interface CustomerDisplayReactivateProps {
  readonly campaign: DetailedCampaignWithStatusAndLoadingFalse;
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onConfirm: (hasTimePeriod: boolean, startDate: Date, endDate: Date) => void;
}

function CustomerDisplayReactivate({ open, campaign, onClose, onConfirm }: CustomerDisplayReactivateProps) {
  const [hasTimePeriod, setHasTimePeriod] = useState(!!campaign.end_date);
  const [startDate, setStartDate] = useState(tomorrow());
  const [endDate, setEndDate] = useState(tomorrow());
  const disableUpdate = hasTimePeriod && isAfter(new Date(), startDate);

  const handleChangeDate = (start: Date, end: Date) => {
    setStartDate(start);
    setEndDate(end);
  };

  const handleConfirm = () => {
    onConfirm(hasTimePeriod, startDate, endDate);
  };

  return (
    <Modal open={open}>
      <Modal.Title>Update Campaign Time Period</Modal.Title>
      <Modal.Body>
        <div className="mb-4 border-b border-neutral-200 pb-2 text-xs text-neutral-500">ACTIVE PERIOD</div>
        <div className="mb-4 flex">
          <Checkbox role="checkbox" checked={hasTimePeriod} onChange={(e) => setHasTimePeriod(e.currentTarget.checked)} />
          <Text variant="body-1" color="default" className="ml-2">
            Set campaign time period
          </Text>
        </div>
        <div className="mb-4 flex flex-col gap-2 text-neutral-500">
          <span>
            Without setting a time period, this campaign will run indefinitely starting tomorrow. It can be configured at a later time.
          </span>
          <span>To get images immediately after setting up campaign, restart Moka APP on your tablet.</span>
        </div>
        <div className="flex items-center gap-2">
          <Text className="text-neutral-700">Select date</Text>
          <DatePicker
            dates={[tomorrow(), null]}
            startDate={startDate}
            endDate={endDate}
            onChangeDate={handleChangeDate}
            rangePicker
            allDay
            disabled={!hasTimePeriod}
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        buttons={
          <Button name="reactivate" disabled={disableUpdate} onClick={handleConfirm}>
            Update
          </Button>
        }
        onCancel={onClose}
      />
    </Modal>
  );
}

export default CustomerDisplayReactivate;
